import { goTo } from '@adornis/router/client/open-href.js';
import { logout as internalLogout } from '@adornis/users/client/loginFunctions.js';
import { OnlineStatus } from '../db/online-status.js';

export const logout = async () => {
  await OnlineStatus.userLogout()().catch(() => {});
  await internalLogout();
  await goTo('/');
};
